import { ColumnType } from 'antd/es/table';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import { phaseApis } from "../../api/Phase";
import dayjs from "dayjs";
import { tasksApis } from '../../api/NewTasks';

const DependencyViolationReport = () => {
    const [userIdFilterData, setUserIdFilterData] = useState([]);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { id: projectId, projectName } = location.state || {};

    const columns: ColumnType<any>[] = [
        {
            title: "Task Name",
            dataIndex: "TaskName",
            key: "TaskName",
            width: 200,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`Task-${record?.taskId}`}
                            onClick={() => {

                                navigate(`/pms/project/task-detail/${record.taskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Predecessor Task",
            dataIndex: "PredecessorTask",
            key: "PredecessorTask",
            width: 200,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`Task-${record?.taskId}`}
                            onClick={() => {

                                navigate(`/pms/project/task-detail/${record.predecessorTaskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Successor Task",
            dataIndex: "SuccessorTask",
            key: "SuccessorTask",
            width: 200,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`Task-${record?.taskId}`}
                            onClick={() => {

                                navigate(`/pms/project/task-detail/${record.successorTaskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Dependency Type",
            dataIndex: "dependencyType",
            key: "dependencyType",
            width: 150,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Defined Lag",
            dataIndex: "definedLag",
            key: "definedLag",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Actual Lag",
            dataIndex: "actualLag",
            key: "actualLag",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Planned StartDate",
            dataIndex: "taskPlanedStartDate",
            key: "taskPlanedStartDate",
            width: 150,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Planned EndDate",
            dataIndex: "taskPlanedEndDate",
            key: "taskPlanedEndDate",
            width: 150,
            render: (text: string) => text || "N/A",
        },
        {
            title: "Actual StartDate",
            dataIndex: "actualStartDate",
            key: "actualStartDate",
            width: 150,
            render: (text: string) => text || "N/A",
        },
        {
            title: "Actual EndDate",
            dataIndex: "actualEndDate",
            key: "actualEndDate",
            width: 150,
            render: (text: string) => text || "N/A",
        },
        {
            title: "Assigned To",
            dataIndex: "assignedTo",
            key: "assignedTo",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
    ]


    const fetchStatusDropdown = async () => {
        try {
            const response = await tasksApis.getOwnersFilterData(
                projectId?.toString()
            );
            const { data, status } = response || {};
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };

                });
                setUserIdFilterData(options);
            }
        } catch (error) {
            console.error("eroor")
        }
    }

    useEffect(() => {
        fetchStatusDropdown();
        dispatch(
            updateMenuData([
                {
                    text: "Dependency Violation Report",
                    link: "pms/dependency-violation-report",
                },
            ])
        );
    }, []);
    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='Dependency Violation Report'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Custom Date Range",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "UserId",
                            label: "Users",
                            options: userIdFilterData,
                        },

                    ]
                }}
            />
        </>
    )
};

export default DependencyViolationReport;
